import { gql } from 'urql';

export const LIST_ORDENES_COMPRA = gql`
  query ListOrdenesCompra($filters: OrdenCompraFilterInput, $pagination: PaginationInput, $search: String) {
    listOrdenesCompra(filters: $filters, pagination: $pagination, search: $search) {
      items {
        id
        proveedorId
        proveedorNombre
        fecha
        estado
        total
      }
      pageInfo {
        total
        limit
        offset
      }
    }
  }
`;

export const GET_ORDEN_COMPRA = gql`
  query GetOrdenCompra($id: ID!) {
    getOrdenCompra(id: $id) {
      id
      proveedorId
      proveedorNombre
      fecha
      estado
      observacion
      total
      items {
        id
        productoId
        descripcion
        cantidad
        precioUnit
        dtoPorc
        subtotal
        cantidadRecibida
      }
    }
  }
`;

export const CREATE_ORDEN_COMPRA = gql`
  mutation CreateOrdenCompra($input: OrdenCompraInput!) {
    createOrdenCompra(input: $input) {
      id
    }
  }
`;

export const UPDATE_ORDEN_COMPRA = gql`
  mutation UpdateOrdenCompra($id: ID!, $input: OrdenCompraUpdateInput!) {
    updateOrdenCompra(id: $id, input: $input) {
      id
    }
  }
`;

export const DELETE_ORDEN_COMPRA = gql`
  mutation DeleteOrdenCompra($id: ID!) {
    deleteOrdenCompra(id: $id)
  }
`;

export const CERRAR_ORDEN_COMPRA = gql`
  mutation CerrarOrdenCompra($id: ID!) {
    cerrarOrdenCompra(id: $id) {
      id
      estado
    }
  }
`;
